import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/invoice/paper";

export function listMyDownloads() {
  return request({
    url: prefix + '/listMyDownloads',
    method: 'get',
  })
}

